module.exports = __webpack_public_path__ + "img/icon1.79047bbd.png";